import React, {useState, useEffect, useRef} from 'react'
import axios from 'axios';

import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import { PaginationImages } from './Pagination/ImgPagination';

import InComponentLoader from './Loader/componentloader';
import ThumbnailGrid from './Thumbnail/thumbnail';
import { API_URL, BASE_URL_RECURSOS } from '../../constants';
import { toBase64, updateValueInJson } from '../../functions';

function ImgUploader(props) {

    const [imgstate, setimgstate] = useState({selectedImage: false});
    const [loading, setloading] = useState(false);
    const [user, setuser] = useState(cookie.load('user'));

    const unSelectImage = () => {
        let _tmp = {};
        _tmp["selectedImage"] = false;

        setloading(false);
        setimgstate(_tmp);
        props.onChange("", "");
    }

    const onDrop = (file_container) => {
        if(file_container.length < 1) {
            toast.info("Debe seleccionar una imagen");
            return;
        }
        // flag {selectImage, selectedFile}

        var file = file_container[0];

        if(file){
          toBase64(file)
          .then(data => {

            console.log("base64", data);

            let _tmp = {};
            _tmp["selectedImage"]        = file;
            _tmp["selectedImage"].base64 = data;
            setimgstate(_tmp);
            uploadImage(_tmp);

          }).catch(e => {
            toast.error("Ocurrió un error al analizar el archivo, por favor seleccione otro");
          });

        }else{
          let _tmp = {};
          _tmp["selectedImage"] = false;
          setimgstate(_tmp);
        }
    }

    const uploadImage = (img) => {
      
        let _file                   = img.selectedImage;
        let _filename               = _file.name
        let formData = {};

        formData.sArchivoNombre     = _filename;
        formData.sArchivoID         = "03977376-4DEF-45BA-B810-934A55A6DA16"
        formData.sArchivoExtension  = _filename.substring(_filename.lastIndexOf(".")+1, _filename.length)
        formData.sArchivoTipo       = "imagenes"
        formData.sCategoriaArchivo  = "banner_evento"
        formData.sArchivoData       = _file.base64;
        formData.nCodigoUsuario     = user.nUsuCodigo;
  
        toast.info("Por favor espere mientras la imagen es procesada");
        //console.log(formData);
        
        setloading(true);
        axios.post((API_URL+`FileUX/`),
        ("'"+JSON.stringify(formData)+"'"),
        {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then( data => {
            toast.success("La imagen ha sido subida correctamente")
            console.log(data);
            // Select uploaded image
            setloading(false);            
            let _tmp = {};

            if(props.onChange){
                props.onChange(BASE_URL_RECURSOS + data.data.result.sArchivoRuta, data.data.result.nArchivoCodigo);
            }     
            
        }).catch((error)=> {
            console.error(error);
            toast.error('Error al subir la imagen');

            unSelectImage();
        });
        
    }

    const readFile = (event) => {
        let files = event.target.files;
        console.log(files);
        onDrop(files);
    }

    const changeModalFlag = () => {
        props.modalImg();
    }

    const inputRef = useRef();

    // console.log(imgstate.selectedImage);
    // console.log(props.value);

    /*
        {(props.value !== "" && props.value !== undefined && props.value !== null) 
        ?
            <div>
                {BASE_URL_RECURSOS + props.value}
            </div>
        :
            <div>
                { !imgstate.selectedImage ?
                    <span>
                        Seleccione .. 
                    </span>
                    :
                    <span>
                        {imgstate.selectedImage.name} ...
                    </span>
                }
            </div>
        }
    */

    const changeTextValue = (e) => {
        const {value} = e.target;

        if(props.onChange){
            props.onChange(value, "");
        }   
    }

    return (
        <div>
            <div className="form-control-file-container">
                <div className="content-input-file">
                    <input 
                        name={props.name ? props.name : "fileInputSelector"}
                        id={props.id ? props.id : "fileInputSelector"}
                        type="file" 
                        onClick={(event)=> { event.target.value = null }}
                        onChange={(event)=> { readFile(event) }}
                        ref={inputRef}
                    />  

                    <input 
                        type="text" 
                        className='form-control text-filter__form-control' 
                        placeholder='url ..'
                        value={props.value}
                        onChange={(e)=> changeTextValue(e)}
                    />
                </div>

                <div className='d-inline-flex'> 
                    {props.modalImg &&
                        <button
                            onClick={() => changeModalFlag()}
                            disabled={loading}
                            type="button" 
                            className="btn btn-primary btn-primary__tool btn-img-search"
                            data-toggle="modal" 
                            data-target="#select-images-modal"
                        >
                            <i className='fa fa-picture-o'></i>
                        </button>
                    }

                    <button
                        disabled={loading}
                        onClick={() => inputRef.current.click()}
                        className='btn btn-primary btn-primary__tool btn-img-select'
                    >
                        {loading ? <i className='fa fa-spin fa-spinner'></i> : <i className='fa fa-picture-o'></i>}
                    </button>
                </div>
                    
            </div>
        </div>
    )
}

export const ModalImages = (props) => {

    const [loading, setloading] = useState(true);
    const [imagesToSelect, setimagesToSelect] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);

    const getImages = ( page = 1 ) => {
        const urlBase  = `${API_URL}`
        axios.get(urlBase + `FileUX/0/${page}/all/all/all`).then(response => response.data)
        .then((data) => {

            setloading(false);
            setimagesToSelect(data.result);
            setcurrentPage(page);

        }).catch(error => {
            console.error(error);
        });
    }

    const selectImage = (img_obj) => {
        // Set this.state properties
        if(props.onSelectImg && props.flag){
            props.onSelectImg(props.flag, img_obj.sArchivoRuta, img_obj.nArchivoCodigo);
            document.getElementById("select-images-modal").click();
        }

        setcurrentPage(1);
        getImages(1);
    } 

    useEffect(() => {
        if(loading){
            getImages();
        }
    }, []);
    
    return (
        <div>

            {/* Modals */}
            <div 
                className="modal fade" 
                id="select-images-modal" 
                tabIndex="-1" 
                role="dialog" 
                aria-labelledby="" 
                aria-hidden="true"
            >
                <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body modal-subscription__body">
                            <p className="modal-subscription__title">Imagenes</p>

                            <p className="modal-subscription__info">
                                <div className="recursos__wrapper-table">
                                {!loading
                                    ? 
                                        <ThumbnailGrid 
                                            selectImage={(data) => selectImage(data)}
                                            img_links={imagesToSelect}
                                            changePage={getImages}
                                            sizeX={"150px"} sizeY={"150px"} 
                                        />
                                    : 
                                        <InComponentLoader 
                                            show={true} 
                                            message={"Se están obteniendo las imagenes, por favor espere un momento"} 
                                        />
                                    }
                                </div>
                            </p>
                            
                            {imagesToSelect.length > 0 &&
                                <PaginationImages 
                                    imgArray={imagesToSelect}
                                    currentImagePage={currentPage}
                                    getImages={getImages}
                                />
                            }
                            
                        </div>

                        <div className="modal-footer">
                            <button id="thumbnail-modal-close" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                <i className="fas fa-close fa-sm"></i> &nbsp;
                                <span>Cerrar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ImgUploader;